import { render, staticRenderFns } from "./BusinessOpportunity.vue?vue&type=template&id=a228bd70&"
import script from "./BusinessOpportunity.vue?vue&type=script&lang=js&"
export * from "./BusinessOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./BusinessOpportunity.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports